<fa-icon [icon]="faUserSolid"></fa-icon>
<span class="login-label">
  {{ 'header.auth.signIn' | transloco }}
</span>
